export const buildFullName = ({ Prefix, FirstName, MiddleName, LastName, Suffix }) =>
  [Prefix, FirstName, MiddleName, LastName, Suffix].filter(Boolean).join(' ');
